<!-- KPI client : le rendu dépend de l’offre (persona / duo / pro) fournie par DashboardLayout. -->
<template>
  <div class="content content--premium" :class="`content--offer-${offerSegment}`">
    <DashboardView />
  </div>
</template>

<script>
import { computed, inject } from 'vue';
import DashboardView from '@/components/dashboard/Dashboard.vue';
import { MODULE1_CLIENT_OFFER_KEY } from '@/features/patrimoine/injectionKeys';
import { normalizePayableOffer } from '@/utils/paymentPricing';

export default {
  name: 'Dashboard',
  components: {
    DashboardView,
  },
  setup() {
    const injectedOffer = inject(MODULE1_CLIENT_OFFER_KEY, null);
    const offerSegment = computed(() =>
      normalizePayableOffer(injectedOffer?.value || 'persona'),
    );
    return { offerSegment };
  },
};
</script>

<style scoped>
.content--premium {
  max-width: 100%;
  overflow-x: hidden;
}
</style>
